/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Tab_DrawInputs */

const en_cad_features_tab_draw = /** @type {(inputs: Cad_Features_Tab_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw`)
};

/**
* | output |
* | --- |
* | "Draw" |
*
* @param {Cad_Features_Tab_DrawInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_tab_draw = /** @type {((inputs?: Cad_Features_Tab_DrawInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Tab_DrawInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_tab_draw(inputs)
});
export { cad_features_tab_draw as "cad.features.tab_draw" }